module.exports = __webpack_public_path__ + "static/img/weather37.936b0ecd.png";